import { SaveOutlined } from "@ant-design/icons";
import { Card, Input, Select, Tag } from "antd";
import { Option } from "antd/es/mentions";
import axios from "axios";
import {
  Button,
  DeleteButton,
  Export,
  Form,
  Modal,
  Table,
  TableCard,
} from "components";
import React, { useEffect, useState } from "react";
import {
  FaPen,
  FaPlus,
  FaCheckToSlot,
  FaDownload,
  FaXmark,
  FaFileArrowDown,
  FaFileArrowUp,
  FaTrash,
} from "react-icons/fa6";
import { Link, useLocation, useParams } from "react-router-dom";

function Order_Details() {
  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [costumer, setCostumer] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [payment, setPayment] = useState([]);
  const [price, setPrice] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [form] = Form.useForm();
  const { id } = useParams();

  const status = [
    { label: <Tag color="error">Идэвхтэй</Tag>, value: 0 },
    { label: <Tag color="processing">Идэвхгүй</Tag>, value: 1 },
  ];

  useEffect(() => {
    getData();
    getWarehouse();
    getProducts();
    // getCostumer();
    // getPayment();
  }, []);

  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `buying/detail/${id}`,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  const getProducts = () => {
    axios({
      method: "get",
      url: "/products",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            id: item.id,
            text: item.name,
            price: item.price
          }
          )
        );
        setProductData(tmp);
      })
      .catch(() => {});
  };

  const getCostumer = () => {
    axios({
      method: "get",
      url: "/customers",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setCostumer(tmp);
      })
      .catch(() => {});
  };
  const getPayment = () => {
    axios({
      method: "get",
      url: "/paymenttypes",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setPayment(tmp);
      })
      .catch(() => {});
  };
  const getWarehouse = () => {
    axios({
      method: "get",
      url: "/warehouses",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setWarehouse(tmp);
      })
      .catch(() => {});
  };

  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "  ",
      dataIndex: "product.image",
      key: "image",
      width: 50,
      cellRender: ({ value, data }) => (
        <div className="">
          <img src={`${process.env.REACT_APP_CDN_URL}${value}`} alt="" />
        </div>
      ),
    },
    {
      title: "Бараа",
      dataIndex: "product.name",
      key: "productname",
    },
    {
      title: "Код",
      dataIndex: "product.code",
      key: "productcode",
    },
    {
      title: "Үнэ",
      dataIndex: "price",
      key: "price",
      // cellRender: ({ value, data }) => (
      //   <div>{costumer.find((item) => item?.value === value)?.label}</div>
      // ),
    },
    {
      title: "Тоо",
      dataIndex: "qty",
      key: "qty",
      // cellRender: ({ value, data }) => (
      //   <div>{payment.find((item) => item?.value === value)?.label}</div>
      // ),
    },
    {
      title: "Дүн",
      dataIndex: "totalamount",
      key: "totalamount",
    },
    // {
    //   title: "Төлөв",
    //   dataIndex: "status",
    //   key: "status",
    //   cellRender: ({ value, data }) => (
    //     <div>{status.find((item) => item?.value === value)?.label}</div>
    //   ),
    // },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 90,
      cellRender: ({ value, data }) => (
        <div className="action-cell flex items-center gap-2">
          {/* <Button
            type="ghost"
            size="sm"
            icon={<FaPen />}
            onClick={() => handleEditButton(data)}
          /> */}
          <DeleteButton onClick={() => handleDelete(data)} />
        </div>
      ),
    },
  ];
  const fields = [
    {
      label: "Бараа",
      name: "productid",
      type:'select',
      rules: [{ required: true, message: "Бараа оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: { 
        options:  productData,
      },
    }, 
    {
      label: "Агуулах",
      name: "warehouseid",
      type:'select',
      rules: [{ required: true, message: "Агуулах оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {
        options: warehouse,
      },
    }, 
    {
      label: "Тоо ширхэг",
      name: "gty",
      type: 'number',
      rules: [{ required: true, message: "Тоо ширхэг оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    }, 
  
    {
      label: "Үнэ",
      name: "price",
      type: 'number',
      rules: [{ required: true, message: "Үнэ оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    }, 
    {
      label: "Нийт үнийн дүн",
      name: "totalamount",
      type: 'number',
      rules: [{ required: true, message: "Нийт үнийн дүн оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    }, 
    // {
    //   type: 'component',
    //   fieldName: 'type1',
    //   component: (
    //     <div className="col-span-12">
    //       <Form.List name='product' initialValue={[{}]}>
    //         {(fields, { add, remove }) => (
    //           <div className="col-span-12">
    //             <table className='col-span-12 mt-6 items-center rounded-lg border-separate border-spacing-2 border border-slate-200'>
    //               <thead className="items-center mt-2" style={{ display: fields.length > 0 ? 'table-header-group' : 'none' }}>
    //                 <tr>
    //                   <th style={{ width: '5%' }}></th>
    //                   <th style={{ width: '25%' }}>Бараа</th>
    //                   <th style={{ width: '5%' }}>Үнэ</th>
    //                   <th style={{ width: '25%' }}>Агуулах</th>
    //                   <th style={{ width: '15%' }}>Тоо ширхэг</th>
    //                   <th style={{ width: '15%' }}>Нийт дүн</th>
    //                   <th style={{ width: '10%' }}></th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {fields.map((field, index) => (
    //                   <tr key={field.key}>
    //                     <td style={{ width: '5%' }}>
    //                       <div className="mb-6">{index + 1}</div>
    //                     </td>
    //                     <td style={{ width: '25%' }}>
    //                       <Form.Item name={[index, 'productid']}>
    //                         <Select
    //                           placeholder="Бараа сонгоно уу"
    //                           onChange={(value) => {
    //                             const selectedProduct = productData.find((product) => product.value === value);
    //                             if (selectedProduct) {
    //                               form.setFieldValue(['product', index, 'price'], selectedProduct.price);
    //                             }
    //                           }}
    //                         >
    //                           {productData.map((opt) => (
    //                             <Option key={opt.value} value={opt.value} label={opt.label}>
    //                               {opt.label}
    //                             </Option>
    //                           ))}
    //                         </Select>
    //                       </Form.Item>
    //                     </td>
    //                     <td style={{ width: '5%' }}>
    //                       <Form.Item name={[index, 'price']}>
    //                         <Input className='border h-8' readOnly />
    //                       </Form.Item>
    //                     </td>
    //                     <td style={{ width: '25%' }}>
    //                       <Form.Item name={[index, 'warehouseid']}>
    //                         <Select placeholder="Агуулах сонгоно уу">
    //                           {warehouse.map((opt) => (
    //                             <Option key={opt.value} value={opt.value} label={opt.label}>
    //                               {opt.label}
    //                             </Option>
    //                           ))}
    //                         </Select>
    //                       </Form.Item>
    //                     </td>
    //                     <td style={{ width: '15%' }}>
    //                     <Form.Item
    //                     name={[ index, 'qty']}
    //                     rules={[
    //                       {
    //                         required: false,
    //                         message: 'Qty код оруулна уу',
    //                       },
    //                     ]}
    //                   >
    //                     <Input 
    //                       className="border h-8"
    //                       onChange={(e) => {
    //                         const quantity = parseInt(e.target.value);
    //                         const productId = form.getFieldValue(['order_details', index, 'productid']); 
    //                         const selectedProduct = productData.find(product => product.id === productId); 
    //                         if (selectedProduct && !isNaN(quantity) && !isNaN(selectedProduct.price)) {
    //                           const totalAmount = quantity * selectedProduct.price;
    //                           setPrice(totalAmount)
    //                           form.setFieldValue(['product', index, 'totalamount'], totalAmount);
    //                         }
    //                       }}
    //                     />
    //                   </Form.Item>
    //                     </td>
    //                     <td style={{ width: '15%' }}>
    //                       <Form.Item name={[index, 'totalamount']} >
    //                         <Input className='border h-8' readOnly/>
    //                       </Form.Item>
    //                     </td>
    //                     <td style={{ width: '10%' }}>
    //                       {index === 0 ? null : (
    //                         <Button icon={<FaTrash />} className='flex items-center mb-6 cursor-pointer justify-center bg-[#F0F1F3] rounded-md' onClick={() => remove(field.name)} />
    //                       )}
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //             {!editData && (
    //             <Button className='w-full mt-2 ' iconPosition='right' onClick={() => { add(); }}>
    //               Бараа нэмэх
    //             </Button>
    //             )}
    //           </div>
    //         )}
    //       </Form.List>
    //     </div>
    //   )
    // }
    
  ];
  
  const handleConfirm = (values) => {
    if (data.status !== 1) {
        return;
    }
  
    setActionLoading(true);
    axios({
      method: "post",
      url: `/buying/confirm/${id}`,
    })
    .then((res) => {
      getData();
    })
    .catch((err) => {})
    .finally(() => {
      setActionLoading(false);
    });
  };  

  const handleStatusCancel = (values) => {

    console.log(data.status);

    if (data.status !== 1) {
        return;
    }
  
    setActionLoading(true);
    axios({
      method: "post",
      url: `/buying/cancel/${id}`,
    })
    .then((res) => {
      getData();
    })
    .catch((err) => {})
    .finally(() => {
      setActionLoading(false);
    });
  };  

  const handleSubmit = (values) => {
    setActionLoading(true);
    if (editData) {
      axios({
        method: "put",
        url: `buying/detail`,
        data: {
          ...values,
          id: parseInt(editData.id),
          buyingid:id,

        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        url: `/buying/detail`,
        data: {
          ...values,
          buyingid:id,
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    }
  };

  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditButton = (data) => {
    setEditData(data);
    setShowModal(true);
    form.setFieldsValue({
    });


  };

  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/buying/detail/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };
  return (
    <div className="mainCard px-10 ">
      <div className=" border drop-shadow-lg w-full border-gray-200 bg-white py-4 px-6 rounded-xl mb-10">
        <div className="flex font-sans mx-2">
          <div className="flex-auto p-6 ">
            <div className="grid grid-cols-2 gap-4">
                <Card className="drop-shadow mx-8">
                <div className="flex flex-wrap">
                  <h1 className="flex-auto text-lg font-semibold text-slate-900">
                    Гарчиг: {data.title}
                  </h1>
                  <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                    ID: {id}
                  </div>
                  <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                    Барааны тоо: {data.qty}
                  </div>
                  <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                    Дүн: {data.totalamount}

                  </div>
                  <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                    Төлөв:
                    <Tag
                      color={
                        data.status === 1
                          ? "warning"
                          : data.status === 2
                          ? "success"
                          : data.status === 3
                          ? "blue"
                          : data.status === 4
                          ? "success"
                          : data.status === 5
                          ? "red"
                          : data.status === 6
                          ? "error"
                          : null
                      }
                    >
                      {data.status === 1
                        ? "Хүсэлт"
                        : data.status === 2
                        ? "Баталгаажсан"
                        : data.status === 3
                        ? "Хүргэсэн"
                        : data.status === 4
                        ? "Тооцоо хаасан"
                        : data.status === 5
                        ? "Буцаасан"
                        : data.status === 6
                        ? "Цуцалсан"
                        : null}
                    </Tag>
                  </div>
                  <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                    Тайлбар:
                  </div>
                  <div>{data.description}</div>
                </div>
                </Card>
                <Card className="drop-shadow mx-8">
                <div className="grid grid-cols-5">
                  {/* <div className="col-span-2">
                    <img src={`${process.env.REACT_APP_CDN_URL}${data?.image}`} alt="" />
                  </div> */}
                  <div className="col-span-full">
                    <h1 className="flex-auto text-lg font-semibold text-slate-900">
                        Нийлүүлэгч: {data?.vendor?.name}
                      </h1>
                      <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                        РД: {data.vendor?.registerno}
                      </div>
                      <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                        Утас: {data.vendor?.phone}
                      </div>
                      <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2 mb-4">
                        Хаяг: {data.vendor?.address}
                      </div>
                    
                    <div className=" border-t border-slate-200 text-sm font-medium mt-2">
                      <div className="grid grid-rows-2 mt-4 gap-2">
                        <div className=" font-semibold">
                          Захиалсан огноо: {data.buyingdate}
                        </div>
                        {/* <div className="font-semibold">
                          Хүргэсэн огноо: {data.deliverydate}
                        </div> */}
                      </div>
                  </div>
                  </div>
                </div>
                </Card>
            </div>
            <div className="flex items-center justify-end gap-2 mt-4 mr-8">
              {/* <Button icon='' onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button> */}
              <Button
                type="primary"
                icon={<FaCheckToSlot />}
                onClick={handleConfirm}
                disabled={data.status !== 1}
              >
                Батлах
              </Button>
              <Button 
                type="danger" 
                icon={<FaXmark />}
                onClick = {handleStatusCancel}
                disabled={data.status !== 1}
              >
                Цуцлах
              </Button>
            </div>
          </div>
        </div>{" "}
      </div>
      <TableCard
        header={
          <div className="flex flex-col">
            <div className="w-full flex justify-between items-center gap-4">
              <h1 className="text-2xl font-medium"></h1>
              <div className="flex items-center gap-2">
                {/* <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button> */}
                {/* <Button icon={<FaFileArrowDown />} onClick={() => {}}>
                  Excel оруулах
                </Button> */}
                <Export fileData={data} fileName={"Захиалгийн бараа"} />
                <Button
                  type="primary"
                  icon={<FaPlus />}
                  onClick={handleAddButton}
                  disabled={data.status !== 1}
                >
                  Нэмэх
                </Button>
              </div>
            </div>
          </div>
        }
      >
        <Table
          dataSource={data.buying_details}
          columns={columns}
          loading={loading}
        />
        <Modal
          // style={{ maxWidth: "80%", minWidth: "70%" }}
          title={editData ? "Засах" : "Шинээр нэмэх"}
          open={showModal}
          onCancel={handleCloseModal}
        >
          <Form
            form={form}
            fields={fields}
            editData={editData}  
            initialValues={editData}  
            onFinish={handleSubmit}
            className={"gap-2"}
          >
            <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
              <Button
                type="primary"
                onClick={() => form.submit()}
                loading={actionLoading}
                icon={<SaveOutlined />}
              >
                Хадгалах
              </Button>
              <Button onClick={handleCancel} disabled={actionLoading}>
                Цуцлах
              </Button>
            </div>
          </Form>
        </Modal>
      </TableCard>
    </div>
  );
}

export default Order_Details;
